import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

interface TTLPickerProps {
  value: { preset?: string; custom?: string }
  onChange: (value: { preset?: string; custom?: string }) => void
}

const presets = [
  { key: '1w', label: '1 week' },
  { key: '2w', label: '2 weeks' },
  { key: '1m', label: '1 month' },
]

export function TTLPicker({ value, onChange }: TTLPickerProps) {
  const [showCustom, setShowCustom] = useState(!!value.custom)

  return (
    <div>
      <Label className="mb-2 block">Expiration</Label>
      <div className="flex flex-wrap gap-2 mb-2">
        {presets.map(p => (
          <Button
            key={p.key}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => {
              setShowCustom(false)
              onChange({ preset: p.key })
            }}
            className={cn(
              !showCustom && value.preset === p.key
                ? 'bg-seed-green-100 text-seed-green-800 border-seed-green-300 hover:bg-seed-green-100'
                : ''
            )}
          >
            {p.label}
          </Button>
        ))}
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => setShowCustom(true)}
          className={cn(
            showCustom
              ? 'bg-seed-green-100 text-seed-green-800 border-seed-green-300 hover:bg-seed-green-100'
              : ''
          )}
        >
          Custom
        </Button>
      </div>

      {showCustom && (
        <Input
          type="datetime-local"
          value={value.custom || ''}
          onChange={e => onChange({ custom: e.target.value })}
          min={new Date().toISOString().slice(0, 16)}
        />
      )}
    </div>
  )
}
